import React from 'react';
import { Card, CardBody } from 'reactstrap';

import dayjs, { monthDisplayFormat } from '~libs/dayjs';

import type { RollbackInvite } from '~support-at-home/actions/statements';

interface ComponentProps {
  invite: RollbackInvite;
}

// TAV-3491: the link sets the company, month and clients. They are shown read only and cannot be changed.
// The month is built from the YYYY-MM string, never a time, so it can never shift to another month.
const Criteria: React.FC<ComponentProps> = ({ invite }) => {
  const clientNames = invite.clients.map((client) => client.name);

  return (
    <Card className="rounded-0" data-cy="statements-rollback-criteria">
      <CardBody>
        <p className="mb-3">These were set by TurnPoint Support in your link and cannot be changed.</p>
        <dl className="row mb-0">
          <dt className="col-12 col-md-3 fw-normal text-muted">Company</dt>
          <dd className="col-12 col-md-9 fw-semibold" data-cy="statements-rollback-company">
            {invite.company.name}
          </dd>
          <dt className="col-12 col-md-3 fw-normal text-muted">Statement Month</dt>
          <dd className="col-12 col-md-9 fw-semibold" data-cy="statements-rollback-month">
            {dayjs(`${invite.month}-01`).format(monthDisplayFormat)}
          </dd>
          <dt className="col-12 col-md-3 fw-normal text-muted">Clients</dt>
          <dd className="col-12 col-md-9 fw-semibold mb-0" data-cy="statements-rollback-clients">
            {clientNames.length === 0 ? (
              'All clients with a statement for this month'
            ) : (
              <ul className="mb-0 ps-3">
                {clientNames.map((name, index) => (
                  <li key={`${invite.clients[index].id}`}>{name}</li>
                ))}
              </ul>
            )}
          </dd>
        </dl>
      </CardBody>
    </Card>
  );
};

export default Criteria;
